import { Chart, LineController, LinearScale, CategoryScale, } from 'chart.js';
import { merge } from 'chart.js/helpers';
import { calculateScale, isNumericScale } from './utils';
import { PointWithErrorBar } from '../elements';
import { generateBarTooltip } from './tooltip';
import { animationHints } from '../animate';
import { getMinMax, parseErrorNumberData, parseErrorLabelData, } from './base';
import patchController from './patchController';
export class LineWithErrorBarsController extends LineController {
    getMinMax(scale, canStack) {
        return getMinMax(scale, (patchedScale) => super.getMinMax(patchedScale, canStack));
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        this.parseErrorData(parsed, meta, data, start, count);
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        this.parseErrorData(parsed, meta, data, start, count);
        return parsed;
    }
    parseErrorData(parsed, meta, data, start, count) {
        parseErrorNumberData(parsed, meta.vScale, data, start, count);
        const iScale = meta.iScale;
        const hasNumberIScale = isNumericScale(iScale);
        if (hasNumberIScale) {
            parseErrorNumberData(parsed, meta.iScale, data, start, count);
        }
        else {
            parseErrorLabelData(parsed, meta.iScale, start, count);
        }
    }
    updateElement(element, index, properties, mode) {
        if (element instanceof PointWithErrorBar && typeof index === 'number') {
            this.updateElementScale(index, properties, mode);
        }
        super.updateElement(element, index, properties, mode);
    }
    updateElementScale(index, properties, mode) {
        calculateScale(properties, this.getParsed(index), index, this._cachedMeta.vScale, mode === 'reset');
        const iScale = this._cachedMeta.iScale;
        const hasNumberIScale = isNumericScale(iScale);
        if (hasNumberIScale) {
            calculateScale(properties, this.getParsed(index), index, this._cachedMeta.iScale, mode === 'reset');
        }
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const c = this.chart;
        const directUpdate = c._animationsDisabled || reset || mode === 'none';
        super.updateElements(points, start, count, mode);
        if (!directUpdate) {
            return;
        }
        for (let i = start; i < start + count; ++i) {
            const point = points[i];
            if (point instanceof PointWithErrorBar) {
                this.updateElementScale(i, point, mode);
            }
        }
    }
}
LineWithErrorBarsController.id = 'lineWithErrorBars';
LineWithErrorBarsController.defaults = merge({}, [
    LineController.defaults,
    animationHints,
    {
        dataElementType: PointWithErrorBar.id,
    },
]);
LineWithErrorBarsController.overrides = merge({}, [
    LineController.overrides,
    {
        plugins: {
            tooltip: {
                callbacks: {
                    label: generateBarTooltip,
                },
            },
        },
    },
]);
LineWithErrorBarsController.defaultRoutes = LineController.defaultRoutes;
export class LineWithErrorBarsChart extends Chart {
    constructor(item, config) {
        super(item, patchController('lineWithErrorBars', config, LineWithErrorBarsController, PointWithErrorBar, [
            LinearScale,
            CategoryScale,
        ]));
    }
}
LineWithErrorBarsChart.id = LineWithErrorBarsController.id;
//# sourceMappingURL=LineWithErrorBarsController.js.map